import { render } from "./SyncElementUsedTemplates.vue?vue&type=template&id=d7289752"
import script from "./SyncElementUsedTemplates.vue?vue&type=script&lang=ts"
export * from "./SyncElementUsedTemplates.vue?vue&type=script&lang=ts"
script.render = render

export default script